import { css } from '@emotion/react';
import { Z_INDEX } from '../../constants/zIndex';
import { SIDE_BAR_WIDTH } from '../../constants/sideBarWidth';

export const locationStyles = {
    desktopWrapper: css({
        width: `${SIDE_BAR_WIDTH}px`,
        position: 'fixed',
        top: '32px',
        left: '32px',
        bottom: '32px',
        backgroundColor: '#FFFFFF',
        borderRadius: '8px',
        zIndex: Z_INDEX.LOCATION_DESKTOP,
        height: 'fit-content',

        '@media (max-width: 600px)': {
            top: '30px',
            left: 0,
            width: '100%',
            height: '100%',
        },
    }),
    contentBox: css({
        display: 'flex',
        flexDirection: 'column',
        padding: '20px 16px',
        height: 'calc(100vh - 134px)',
        overflow: 'auto',
    }),
};
